import instance from "./base.api";

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  id: number;
  username: string;
  nombre: string;
  mail: string;
  rol: string;
  porcentaje: number;
  token: string;
}

export const loginUser = async (data: LoginRequest): Promise<LoginResponse> => {
  const response = await instance.post<LoginResponse>("/auth/login", data);
  return response.data;
};
